import PestPillarLayout from "./PestPillarLayout";

const PROBLEMS = [
  {
    title: "Désinfection après sinistre",
    desc: "Après dégât des eaux, décès, présence prolongée de rongeurs ou d'insectes. Traitement des surfaces, murs, sols et mobilier.",
  },
  {
    title: "Locaux professionnels",
    desc: "Restaurants, boulangeries, cabinets médicaux, gîtes, chambres d'hôtes. Traitement conforme aux exigences sanitaires HACCP.",
  },
  {
    title: "Habitat contaminé",
    desc: "Salubrité, moisissures, bactéries après infestation ou humidité prolongée. Vapeur sèche 180 °C pour surfaces sensibles.",
  },
  {
    title: "Véhicules et intérieurs",
    desc: "Voitures, camping-cars, cabines d'ambulance ou de taxi. Désinfection profonde sans produit chimique par vapeur haute pression.",
  },
  {
    title: "Matelas et literie",
    desc: "Traitement vapeur sèche des matelas, sommiers, canapés, coussins. Éradique bactéries, acariens, punaises de lit, œufs et larves.",
  },
  {
    title: "Points d'eau et sanitaires",
    desc: "Traitement complet des salles de bain, WC, éviers, canalisations. Éradication des bactéries pathogènes et des mauvaises odeurs.",
  },
];

const METHOD = [
  { title: "Évaluation", desc: "Visite sur place, identification de la source de contamination et des zones à traiter." },
  { title: "Devis clair", desc: "Devis gratuit détaillé avec méthode, produits utilisés et durée d'intervention." },
  { title: "Désinfection", desc: "Vapeur sèche 180 °C ou biocide certifié selon la nature du site. Traitement complet, points sensibles inclus." },
  { title: "Certificat", desc: "Attestation de désinfection remise en fin d'intervention (utile pour bailleurs, professionnels HACCP)." },
];

const FAQ = [
  {
    q: "Qu'est-ce que la désinfection professionnelle ?",
    a: "La désinfection consiste à éliminer les micro-organismes pathogènes (bactéries, virus, moisissures) d'une surface ou d'un volume. Elle s'appuie sur des produits homologués (biocides TP2) ou sur des méthodes physiques (vapeur sèche haute température). Contrairement au simple nettoyage, elle détruit les agents infectieux.",
  },
  {
    q: "Quand faire appel à une entreprise de désinfection en Creuse ?",
    a: "Après un dégât des eaux, une infestation de nuisibles (rongeurs, insectes), un décès à domicile, une inondation, ou pour l'entretien réglementaire de locaux professionnels (restaurants, cabinets médicaux, chambres d'hôtes). Aussi pour une remise en état avant vente ou location.",
  },
  {
    q: "La vapeur sèche est-elle vraiment efficace ?",
    a: "Oui : à 180 °C, la vapeur sèche détruit 99,9 % des bactéries, virus, acariens, œufs d'insectes et moisissures en surface. Elle pénètre dans les tissus, fissures et micro-porosités inaccessibles aux produits chimiques classiques. C'est notre méthode privilégiée pour matelas, canapés et locaux sensibles.",
  },
  {
    q: "La désinfection nécessite-t-elle un traitement chimique ?",
    a: "Pas toujours. Nous privilégions systématiquement la vapeur sèche quand elle est adaptée (surfaces textiles, matelas, sanitaires). Les biocides TP2 (bactéricides, virucides, fongicides) sont utilisés uniquement quand la vapeur seule est insuffisante, dans des dosages homologués et avec temps d'aération respectés.",
  },
  {
    q: "Fournissez-vous un certificat de désinfection ?",
    a: "Oui, systématiquement. En fin d'intervention, nous remettons une attestation détaillée mentionnant le lieu, la date, les zones traitées, la méthode et les produits utilisés (si applicable). Ce document est utile pour les bailleurs, les assurances, les professionnels soumis à HACCP ou pour toute revente.",
  },
  {
    q: "Combien coûte une désinfection en Creuse ?",
    a: "Le coût dépend de la surface, de la méthode et de l'accessibilité. Comptez entre 100 € pour une désinfection matelas + sommier, 250-500 € pour un studio complet, et 600-1500 € pour un logement de 100 m² après sinistre. Devis gratuit après visite.",
  },
];

const CITIES = ["Guéret", "La Souterraine", "Aubusson", "Bourganeuf", "Boussac", "La Celle-Dunoise", "Felletin", "Bénévent-l'Abbaye", "Dun-le-Palestel", "Sainte-Feyre"];

export default function DesinfectionCreuse() {
  return (
    <PestPillarLayout
      slug="desinfection-creuse"
      seoTitle="Désinfection Creuse (23) — Vapeur sèche | K'REUSE EXTÉRIEUR"
      seoDescription="Désinfection Creuse à la vapeur sèche 180°C et biocides Certibiocide. Après sinistre, punaises, locaux pro. Certificat remis."
      breadcrumbLabel="Désinfection Creuse"
      heroBadge="Désinfection professionnelle · Vapeur sèche"
      heroTitleHtml={`Désinfection en <span class="font-medium text-[#1B5E20]">Creuse (23)</span>`}
      heroSubtitle="Vapeur sèche 180 °C ou biocides certifiés. Après sinistre, infestation, ou entretien de locaux professionnels. Certificat de désinfection remis en fin d'intervention."
      hero_h2="Une désinfection efficace, sans compromis"
      introParagraphs={[
        "K'REUSE EXTÉRIEUR propose un service complet de désinfection en Creuse, adapté aux particuliers et aux professionnels. Notre approche : privilégier la vapeur sèche haute température (180 °C) qui détruit 99,9 % des bactéries, virus, moisissures, acariens et œufs d'insectes sans aucun produit chimique.",
        "Nous intervenons après infestation de nuisibles (rongeurs, cafards, punaises de lit), après un dégât des eaux ou une inondation, pour préparer une remise en location, ou pour l'entretien réglementaire de locaux HACCP (restaurants, boulangeries, cabinets médicaux, chambres d'hôtes en Creuse).",
        "Certifié Certibiocide, nous respectons strictement les protocoles réglementaires et remettons une attestation détaillée en fin d'intervention. Elle sert de preuve pour bailleurs, assurances, exploitants soumis à HACCP ou lors d'une revente immobilière.",
      ]}
      problems={PROBLEMS}
      method={METHOD}
      cities={CITIES}
      faq={FAQ}
      ctaTitle="Un besoin de désinfection ?"
      whatsappText="Bonjour, je souhaite un devis pour une désinfection en Creuse."
    />
  );
}
